import React, { useState } from 'react';
import { User, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { motion } from 'framer-motion';
import '../styles/AuthPage.css';

const AuthPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="auth-page-container">
            <div className="auth-page-header">
                <h2 className="auth-page-title">
                    {isLogin ? 'Sign in to your account' : 'Create new account'}
                </h2>
                <p className="auth-page-subtitle">
                    {isLogin ? "Don't have an account? " : "Already have an account? "}
                    <button
                        onClick={() => setIsLogin(!isLogin)}
                        className="auth-toggle-btn"
                    >
                        {isLogin ? 'Sign up' : 'Sign in'}
                    </button>
                </p>
            </div>

            <div className="auth-form-container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="auth-form-box"
                >
                    <form className="auth-form-element" onSubmit={handleSubmit}>
                        {!isLogin && (
                            <div className="auth-form-group">
                                <label htmlFor="name" className="auth-form-label">
                                    Full Name
                                </label>
                                <div className="auth-input-group">
                                    <div className="auth-input-icon">
                                        <User className="auth-icon" />
                                    </div>
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="auth-input"
                                        placeholder="John Doe"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="auth-form-group">
                            <label htmlFor="email" className="auth-form-label">
                                Email address
                            </label>
                            <div className="auth-input-group">
                                <div className="auth-input-icon">
                                    <Mail className="auth-icon" />
                                </div>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="auth-input"
                                    placeholder="you@example.com"
                                />
                            </div>
                        </div>

                        <div className="auth-form-group">
                            <label htmlFor="password" className="auth-form-label">
                                Password
                            </label>
                            <div className="auth-input-group">
                                <div className="auth-input-icon">
                                    <Lock className="auth-icon" />
                                </div>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="auth-input"
                                    placeholder="••••••••"
                                />
                                <button
                                    type="button"
                                    className="auth-password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <EyeOff className="auth-icon" />
                                    ) : (
                                        <Eye className="auth-icon" />
                                    )}
                                </button>
                            </div>
                        </div>

                        {isLogin && (
                            <div className="auth-form-footer">
                                <div className="auth-remember-me">
                                    <input
                                        id="remember-me"
                                        name="remember-me"
                                        type="checkbox"
                                        className="auth-remember-checkbox"
                                    />
                                    <label htmlFor="remember-me" className="auth-remember-label">
                                        Remember me
                                    </label>
                                </div>

                                <div className="auth-forgot-password">
                                    <a href="#" className="auth-forgot-link">
                                        Forgot your password?
                                    </a>
                                </div>
                            </div>
                        )}

                        <div className="auth-submit-container">
                            <button type="submit" className="auth-submit-button">
                                {isLogin ? 'Sign in' : 'Sign up'}
                            </button>
                        </div>
                    </form>
                </motion.div>
            </div>
        </div>
    );
};

export default AuthPage;